import React, { ReactNode } from 'react';
import formatPrice, { formatPriceExact } from '../../utils/price';
import StyledProductPrices from '../../styled/ProductPrices';

export type PriceObject = {
  sellingPrice: number;
  referencePrice: number;
  pilPrice: number;
  originalPrice: number;
  componentPrice: number;
};

enum FormatType {
  Default = 'default',
  Exact = 'exact',
}

interface IProductPrice {
  priceObject: PriceObject;
  formatType?: FormatType;
  hasPriceFlag?: boolean;
  priceDesign?: TPriceDesign | null;
  badge?: ReactNode;
  inline?: boolean;
  size?: 'large' | 'small';
}

const displayPriceFormatter = (value: number, type: FormatType) =>
  type === FormatType.Exact ? formatPriceExact(value) : formatPrice(value);

export default function ProductPrices({
  priceObject,
  formatType = FormatType.Default,
  badge,
  hasPriceFlag = false,
  priceDesign,
  inline,
  size,
}: IProductPrice) {
  const { sellingPrice, originalPrice, referencePrice, pilPrice, componentPrice } = priceObject;

  const isDiscounted = sellingPrice < originalPrice;

  const sellingDisplayPrice = displayPriceFormatter(sellingPrice, formatType);
  const referenceDisplayPrice = displayPriceFormatter(referencePrice, formatType);
  const pilDisplayPrice = displayPriceFormatter(pilPrice, formatType);
  const originalDisplayPrice = displayPriceFormatter(originalPrice, formatType);
  const componentDisplayPrice = displayPriceFormatter(componentPrice, formatType);

  const compareableReferencePrice = pilPrice || referencePrice;
  const displayOriginalPrice = originalPrice > compareableReferencePrice;

  const displayedReferencePrice = pilDisplayPrice || referenceDisplayPrice;
  const displayReferencePrice = displayedReferencePrice;
  const referencePricePrefix = 'Tidigare lägsta pris:';
  const componentPricePrefix = 'Pris ingående delar:';

  return (
    <StyledProductPrices
      isDiscounted={isDiscounted}
      sellingDisplayPrice={sellingDisplayPrice}
      originalDisplayPrice={originalDisplayPrice}
      displayReferencePrice={displayReferencePrice}
      referencePricePrefix={referencePricePrefix}
      componentPricePrefix={componentPricePrefix}
      displayOriginalPrice={displayOriginalPrice}
      componentDisplayPrice={componentDisplayPrice}
      hasPriceFlag={hasPriceFlag}
      priceDesign={priceDesign}
      badge={badge}
      inline={inline}
      size={size}
    />
  );
}
